import useGlobalQueries from './useGlobalQueries';

export default (feature) => {
  const {
    adminSettings,
    learnerSettings,
    currentUser,
  } = useGlobalQueries();

  const isLearner = currentUser.data?.authority === 'student';
  const query = isLearner ? learnerSettings : adminSettings;
  const { data } = query;
  const enabledFeatures = data?.enabled_features || [];
  const isLabsModuleEnabled = enabledFeatures.includes('labs_module');
  const isLabsFeatureEnabled = Boolean(
    data?.labs_features?.some(({ code }) => code === feature),
  );

  return isLabsModuleEnabled && isLabsFeatureEnabled;
};
